import {
  Card,
  CardContent,
  type CardContentProps,
  type CardRootProps,
} from "#ui/card";
import { Icon } from "#ui/icon";
import { cx } from "#ui/style.utils";
import { H2 } from "#ui/typography";

interface ErrorCardContentProps extends React.ComponentPropsWithoutRef<"div"> {
  heading?: React.ReactNode;
}

export function ErrorCardContent({
  children,
  className,
  heading,
  ...props
}: ErrorCardContentProps) {
  return (
    <div
      {...props}
      className={cx(
        // Same classNames as PendingCardContent - Keep in sync!
        "grid place-content-center place-items-center gap-20px text-center md:min-h-280px md:py-30px",
        className,
      )}
    >
      <Icon
        name="baird-maintenance-circle"
        size="baird-lg"
        palette="warning"
        className="mb-5px"
      />
      <H2 size="h5" className="leading-none">
        {heading ?? "Oops! It looks like we ran into an error."}
      </H2>
      {children}
    </div>
  );
}

export interface ErrorCardProps extends CardRootProps {
  heading?: ErrorCardContentProps["heading"];
  children?: CardContentProps["children"];
}

export function ErrorCard({ children, heading, ...props }: ErrorCardProps) {
  return (
    <Card variant="white-border-and-blur" {...props}>
      <CardContent>
        <ErrorCardContent heading={heading}>{children}</ErrorCardContent>
      </CardContent>
    </Card>
  );
}
